import { Typography } from '@mui/material';

export function EmptySidePanel({ message = 'Select a row to view details.' }) {
  return (
    <Typography sx={{ mt: 2, textAlign: 'center' }} variant="subtitle2">
      {message}
    </Typography>
  );
}
